module.exports = __webpack_public_path__ + "fonts/Abel-400-latin1.7f8f01e.woff2";